import request from "@/utils/request";

// 创建一级代理商
export const  createLevelOneSupplier =(data) =>{
    return request({
        url: "/businessservice/supplier/createLevelOne",
        method:"post",
        data: data
    })
}

// 创建二级代理商
export const  createLevelTwoSupplier =(data) =>{
    return request({
        url: "/businessservice/supplier/createLevelTwo",
        method:"post",
        data: data
    })
}

// 编辑代理商
export const  updateSupplier =(data) =>{
    return request({
        url: "/businessservice/supplier/updateSupplier",
        method:"post",
        data: data
    })
}

// 分页查询代理商
export const  pageSupplier =(data) =>{
    return request({
        url: "/businessservice/supplier/page",
        method:"post",
        data: data
    })
}

// 查询代理商列表
export const  listSupplier =(data) =>{
    return request({
        url: "/businessservice/supplier/list",
        method:"post",
        data: data
    })
}

// 停启用代理
export const  stopOrStartSupplier =(query) =>{
    return request({
        url: "/businessservice/supplier/stopOrStart",
        method:"get",
        params: query
    })
}

// 查询关联一级代理信息
export const  firstSupplierInfo =(query) =>{
    return request({
        url: "/businessservice/supplier/firstInfo",
        method:"get",
        params: query
    })
}

// 查询关联一级代理信息
export const  secondSupplierInfo =(query) =>{
    return request({
        url: "/businessservice/supplier/secondInfo",
        method:"get",
        params: query
    })
}